export enum TeamMemberRoleEnum {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  PROJECT_MANAGER = "PROJECT_MANAGER",
  ACCOUNTANT = "ACCOUNTANT",
  USER = "USER",
}
